// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of ell replacements can be found in `angular.json`.

import { SETTINGS } from './settings';

export const environment = {
  production: false,
  appSettings: SETTINGS,
  version: '2.0.4',
  //apiUrl: 'http://localhost:50002/api',
  //apiUrl: 'http://192.168.2.109:89/api',
  apiUrl: 'https://api.testesdecodigo.com/api',
  //apiUrl: 'https://api.testesdecodigo.graycell.pt/api',
  swagger: 'https://api.testesdecodigo.com/swagger/index.html',
  //  apiUrl: 'http://80.172.233.181/AlvesCostaAPI/api'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
